import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'NCDReferral';
}

// localStorage.setItem('BaseUrl','https://ncdreferral-dev-api.asddigital.org'); // Dev
 localStorage.setItem('BaseUrl','https://ncdreferral-api.asddigital.org'); // Live
// localStorage.setItem('BaseUrl','https://localhost:44323'); //Local
// localStorage.setItem('BaseUrl','http://192.168.100.194:2530/'); //Localy Deployed
